<!-- <div class="page_container" *ngIf="(catalogs$ | async)!.length > 0">
  <table class="listing_table">
    <thead class="header_stiky">
      <tr class="head_table">
        <th>{{"common.image" |translate }}</th>
        <th>{{"common.title" |translate}}</th>
        <th>{{"common.wholesale_discount" | translate}}</th>
        <th>{{"Catalogs.companies_override" |translate}}</th>
        <th>{{"Catalogs.nbr_products" |translate }}</th>
        <th>{{"Catalogs.company_locations" | translate}}</th>
        <th>{{"common.status" | translate}}</th>
        <th>{{"common.created_date" | translate}}</th>
        <th>
         {{"common.actions" | translate}}
        </th>
      </tr>
    </thead>
    <tbody class="scrollable-body">
      <ng-container *ngFor="let catalog of catalogs$ | async; let i = index">
        <tr class="body_table">
          <td class="first_td" (click)="editCatalogs(catalog)">
            <img 
              class="listing_image" 
              [src]="failedImages.has(catalog.image!) ? 'assets/icones/no-image.png' : getImage(catalog.image!)"
              alt=""
              (error)="onImageError(catalog.image!)"
            >
          </td>
          <td class="td_block pointer" (click)="editCatalogs(catalog)">
            <span class="bold_span">{{ catalog.name }}</span>
          </td>
          <td class="td_block">
            <span class="bold_span">{{ catalog.general_discount ? '-' + catalog.general_discount + '%' : 'NONE'}}</span>
          </td>
          <td class="description_cell" (click)="editCatalogs(catalog)">
            <span class="descr_elemnt">
              {{catalog.nbr_locations_with_custom_discount}}
              </span>
            </td>
            <td class="td_date bold_span" (click)="editCatalogs(catalog)">
              {{catalog.create_date | adaptToUserUtcOffset | date: DATE_FORMAT}}
              <img *ngIf="expired(catalog)" src="../../../../../assets/icones/warning.svg" alt="" title="Catalog expired">
            </td>
            <td>
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon style="color: #9d9a9a;">more_vert</mat-icon>
              </button>
            </mat-menu>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div> -->

<div class="agents-container">
  <!-- Section header: title, search and every list action on one row. Action
       order matches Orders and Products — filter, clear, download, then the
       page's own actions, primary last (WB-7275). -->
  <ui-page-header
    class="catalogs-header"
    [title]="'Catalogs.catalogs' | translate"
    lucideIcon="Clipboard"
    [searchable]="true"
    [searchControl]="searchInput"
    [searchPlaceholder]="'agent.catalogue.search' | translate"
    (searchInput)="search($event)"
  >
      <!-- Filter, with its clear badge (see ui-filter-action). -->
      <ui-filter-action
        [active]="hasModuleFilters()"
        (filter)="setFilter()"
        (clear)="clearFilter()"
      ></ui-filter-action>

      <!-- Download -->
      <button
        type="button"
        class="ui-header-action"
        [attr.aria-label]="'agent.actions.download' | translate"
        [matTooltip]="'agent.actions.download' | translate"
        matTooltipPosition="below"
        (click)="downloadCatalogs()"
      >
        <img src="assets/icones/download_icon.svg" alt="" />
      </button>

      <!-- Bulk actions for the current selection live in the floating
           ui-bulk-actions-bar at the bottom of the table, not here. -->

      <!-- Create catalog. Goes straight to a customer catalog: agent catalogs are
           functionally deprecated, so the customer / agent choice this used to
           open is gone. -->
      <ng-container *appHasPermission="{ module: 'catalog', action: 'create' }">
        <ui-button
          type="primary"
          icon="plus-cc"
          [label]="'agent.actions.create_catalog' | translate"
          (click)="addCatalog('client')"
        ></ui-button>
      </ng-container>
  </ui-page-header>
  <div
    class="agents-content"
    [class.agents-content--with-bulk-bar]="selection.hasSelection"
    *ngIf="(catalogs$ | async)!.length > 0"
  >
    <table class="agents-table">
      <thead>
        <tr class="row header">
          <th>
            <ui-checkbox
              [checked]="selection.isAllSelected"
              [indeterminate]="selection.isPartialSelected"
              [ariaLabel]="'common.select_all' | translate"
              (changed)="selection.toggleAll($event.checked)"
            ></ui-checkbox>
            <div
              style="display: flex; flex-direction: row; align-items: center"
            >
              {{ "Catalogs.catalog_name" | translate }}
              <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="
                    activeSortMode == 'asc' && activeSortBy == 'name'
                  "
                  (click)="sortBy('name', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="
                    activeSortMode == 'desc' && activeSortBy == 'name'
                  "
                  (click)="sortBy('name', 'desc')"
                ></span>
              </div>
            </div>
          </th>
          <th>{{ "common.type" | translate }}</th>
          <th>{{ "brands.brands" | translate }}</th>
          <th style="display: flex; flex-direction: row; align-items: center">
            {{ "Catalogs.target" | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortBy == 'locations_count'
                "
                (click)="sortBy('locations_count', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortBy == 'locations_count'
                "
                (click)="sortBy('locations_count', 'desc')"
              ></span>
            </div>
          </th>
          <th style="display: flex; flex-direction: row; align-items: center">
            {{ "agent.listing.orders" | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortBy == 'order_count'
                "
                (click)="sortBy('order_count', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortBy == 'order_count'
                "
                (click)="sortBy('order_count', 'desc')"
              ></span>
            </div>
          </th>
          <th style="display: flex; flex-direction: row; align-items: center">
            {{ "Catalogs.orders_amount" | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortBy == 'total_amount'
                "
                (click)="sortBy('total_amount', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortBy == 'total_amount'
                "
                (click)="sortBy('total_amount', 'desc')"
              ></span>
            </div>
          </th>
          <th
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: start !important;
          "
        >
          {{ "common.create_at" | translate }}
          <div class="sort-actions">
            <span
              class="arrow-up"
              [class.active]="
                activeSortMode == 'asc' && activeSortBy == 'create_date'
              "
              (click)="sortBy('create_date', 'asc')"
            ></span>
            <span
              class="arrow-down"
              [class.active]="
                activeSortMode == 'desc' && activeSortBy == 'create_date'
              "
              (click)="sortBy('create_date', 'desc')"
            ></span>
          </div>
        </th>
          <th
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: start !important;
            "
          >
            {{ "agent.listing.last_order" | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortBy == 'last_order_date'
                "
                (click)="sortBy('last_order_date', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortBy == 'last_order_date'
                "
                (click)="sortBy('last_order_date', 'desc')"
              ></span>
            </div>
          </th>
          <th
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: start !important;
          "
        >
          {{ "common.status" | translate }}
          <div class="sort-actions">
            <span
              class="arrow-up"
              [class.active]="
                activeSortMode == 'asc' && activeSortBy == 'status'
              "
              (click)="sortBy('status', 'asc')"
            ></span>
            <span
              class="arrow-down"
              [class.active]="
                activeSortMode == 'desc' && activeSortBy == 'status'
              "
              (click)="sortBy('status', 'desc')"
            ></span>
          </div>
        </th>
        </tr>
      </thead>
      <tbody class="agents-viewport">
        <ng-container *ngFor="let catalog of catalogs; let i = index">
            <tr class="row body" (click)="editCatalogs(catalog)">
              <td>
                <ui-checkbox
                  [checked]="selection.isSelected(catalog.id!)"
                  [ariaLabel]="'common.select' | translate"
                  (changed)="selection.toggleOne(catalog.id!, $event.checked, $event)"
                ></ui-checkbox>
                <div style="display: flex; gap: 10px; align-items: center; min-width: 0;">
                  <img 
                    class="listing_image"
                    [class]="!catalog.image ? 'no-image' : ''"
                    [src]="failedImages.has(catalog.image!) ? 'assets/icones/default-image-product.svg' : getImage(catalog.image!)"
                    alt=""
                    (error)="onImageError(catalog.image!)"
                  >
                  <span
                    class="truncate"
                    style="width: 200px"
                    [title]="catalog.name"
                  >
                    {{ catalog.name }}
                  </span>
                </div>
              </td>

              <td>
                <span class="tag type-tag" [title]="catalog.type">
                  <img [src]="catalogTypeIcon(catalog.type!)" alt="" >
                  {{ ('Catalogs.new_catalog.settings.catalog_types.' + catalog.type!) | translate }}
                </span>
              </td>

              <td>
                <div style="display: flex; gap: 5px">
                  <span
                    class="tag truncate"
                    *ngFor="let brand of catalog.brands!.slice(0, 1)"
                    [title]="brand.name"
                  >
                    {{ brand.name }}
                  </span>
                  <span
                    class="tag truncate"
                    style="color: #232529"
                    *ngIf="catalog.brands!.length > 1"
                  >
                    + {{ catalog.brands!.length - 1 }}
                  </span>
                </div>
              </td>
              <td>
                <span *ngIf="catalog.type === 'client'">
                {{ catalog.nbr_clients }} {{ (catalog.nbr_clients === 1 ? 'Catalogs.new_catalog.settings.catalog_types.customer' : 'Catalogs.new_catalog.settings.catalog_types.customers') | translate }}
                </span>
                <span *ngIf="catalog.type === 'agent'">
                  {{ catalog.nbr_targets }} {{ (catalog.nbr_clients === 1 ? 'Catalogs.new_catalog.settings.catalog_types.agent' : 'Catalogs.new_catalog.settings.catalog_types.agents') | translate }}
                </span>
              </td>
              <td>
                {{ catalog.order_count }}
              </td>
              <td>
                {{
                  catalog.total_amount
                    ? catalog.total_amount.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) + " €"
                    : "--"
                }}
              </td>
              <td>
                {{ catalog.create_date | date : DATE_FORMAT }}
              </td>
              <td>
                <span style="padding-left: 5px">{{
                  catalog.last_order_date ? (catalog.last_order_date | date : DATE_FORMAT) : "--"
                }}</span>
              </td>
              <td>
                <ui-status-badge
                  *ngIf="hasCatalogStatus(catalog.status)"
                  [label]="catalogStatusI18nKey(catalog.status) | translate"
                  [tone]="catalogStatusTone(catalog.status)"
                ></ui-status-badge>
              </td>
            </tr>
          </ng-container>
      </tbody>
    </table>
    <!-- ─────────────────────────────────────────────────────────────────── -->
    <!-- Bulk actions for the current selection. Floats centred at the       -->
    <!-- bottom of the table, above the pagination row.                      -->
    <!-- ─────────────────────────────────────────────────────────────────── -->
    <ui-bulk-actions-bar *ngIf="selection.hasSelection" [count]="selection.count" (cleared)="selection.clear()">
      <button
        *appHasPermission="{ module: 'catalog', action: 'delete' }"
        class="ui-bulk-action ui-bulk-action--danger"
        (click)="deleteConfirmation()"
      >
        <ui-icon name="Trash2" size="medium"></ui-icon>
        <span>{{ "common.delete" | translate }}</span>
      </button>
    </ui-bulk-actions-bar>
    <!-- ── END BULK ACTIONS BAR ─────────────────────────────────────────── -->

    <app-pagination
      class="catalogs-pagination"
      [pagination]="pagination$ | async"
      (toPageEvent)="toPage($event)"
    ></app-pagination>
  </div>
  <div *ngIf="filter && (catalogs$ | async)!.length === 0  && !(isAppLoading$ | async)" class="no_reseult">
    <ng-container *ngIf="filter?.filters!.length === 0 && !key">
      <img class="no_intense" src="../../../../../assets/icones/no-catalogs.svg" alt="">
      <h3>{{"Catalogs.no_catalogs" | translate}}</h3>
    </ng-container>
    <ng-container *ngIf="filter?.filters!.length > 0 || key">
      <img class="no_intense" src="../../../../../assets/icones/no-result-search.svg" alt="">
      <h3>{{"Catalogs.no_data_search" | translate }}</h3>
    </ng-container>
    <ng-container *ngIf="filter?.filters!.length === 0 && !key">
      <button class="save_btn_pop_up blue_btn" *appHasPermission="{ module: 'catalog', action: 'create' }" (click)="addCatalog('client')">
          <span>{{"common.add" | translate | uppercase}}</span>
          <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </ng-container>
  </div>
</div>
